angular.module('iqxCore')
// Candidate and Consultant Diary custom titles factory
// Overides: calendarEventTitle from angular-bootstrap-calendar-tpls.js
.factory('calendarEventTitle', ["calendarDateFilter", "calendarTruncateEventTitleFilter", function(calendarDateFilter, calendarTruncateEventTitleFilter) {

  function yearView(event) {
    return event.AllDay ? event.title + " (" + calendarDateFilter(event.startsAt, 'date', true) + ", All Day)" : event.title + " (" + calendarDateFilter(event.startsAt, 'datetime', true) + " - " + calendarDateFilter(event.endsAt, 'datetime', true) + ")";
  }

  function monthView(event) {
    return event.AllDay ? event.title + " (All Day)" : event.title + " (" + calendarDateFilter(event.startsAt, 'time', true) + " - " + calendarDateFilter(event.endsAt, 'time', true) + ")";
  }

  function monthViewTooltip(event) {
    return event.title;
  }

  function weekView(event) {
    return event.title;
  }

  function weekViewTooltip(event) {
    return event.title;
  }

  function dayView(event) {
    return event.allDay ? event.title : calendarTruncateEventTitleFilter(event.title, 20, event.height);
  }

  function dayViewTooltip(event) {
    return event.title;
  }

  return {
    yearView: yearView,
    monthView: monthView,
    monthViewTooltip: monthViewTooltip,
    weekView: weekView,
    weekViewTooltip: weekViewTooltip,
    dayView: dayView,
    dayViewTooltip: dayViewTooltip
  };
}])